import { useSanctumAppConfig } from "../../composables/useSanctumAppConfig.js";
import { appendRequestHeaders } from "../../utils/headers.js";
export default async function handleRequestTokenHeader(app, ctx, logger) {
  const appConfig = useSanctumAppConfig();
  if (appConfig.tokenStorage === void 0) {
    throw new Error("`sanctum.tokenStorage` is not defined in app.config.ts");
  }
  const token = await appConfig.tokenStorage.get(app);
  if (!token) {
    logger.debug("[request] authentication token is not set in the storage");
    return;
  }
  const headersToAdd = { Authorization: `Bearer ${token}` };
  logger.debug(
    "[request] add authentication token header",
    Object.keys(headersToAdd)
  );
  ctx.options.headers = appendRequestHeaders(ctx.options.headers, headersToAdd);
}
